import { z } from 'zod';

export const fbMetricsLiveSchema = z.object({
  reach: z.number(),
  frequency: z.number(),
  spend: z.number(),
  impressions: z.number(),
});

export type FBMetricsLive = z.infer<typeof fbMetricsLiveSchema>;
